<template>
  <div>

    <Dialog :visible.sync="exibirModalNovo" header="Lançar Folga" :modal="true" :style="{width: '450px'}" @hide="fecharModal">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Data início</label>							
                <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label>Data final</label>							
                <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>
            </div>
        </div>       
        <h6 class="p-text-bold">Marcações do dia {{ dataPonto }}</h6>	     				
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Salvar" icon="pi pi-check" @click="executarAcao('SALVAR')" />
        </template>        
    </Dialog>

    <Dialog :visible.sync="exibirModalExcluir" header="Excluir Folga" :modal="true" :style="{width: '450px'}" @hide="fecharModal">
        <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
            <span>Excluir folga do dia <b>{{ folgaExcluir.data | datePtBR }}</b>?</span>
        </div>
        <template #footer>
            <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
            <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="executarAcao('EXCLUIR')" />
        </template>
    </Dialog>
  </div>
</template>

<script>
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    props: {
        callback: Function,
    },
    data() {
        return {
            dataPonto: null,
            exibirModalNovo: false,
            exibirModalExcluir: false,
            dataInicio: new Date(),
            dataFinal: new Date(),
            folgaExcluir: {data: ''},
            requisicao: {},
            localeCalendarBR: localeCalendarBR,
            eventoSelecionado: '',
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        processar(req) {   
            this.eventoSelecionado = '';
            this.dataPonto = this.formatarStringData(req.data);
            this.requisicao = {...req};                            
            this.controlePontoService.buscarFolgaPontoDia(req)
            .then(resp => {
                if(resp.data.temFolga) {
                    this.folgaExcluir = resp.data.folga;
                    this.exibirModalExcluir = true;
                } else {
                    this.exibirModalNovo = true;
                    this.dataInicio = this.formatarStringData(req.data);
                    this.dataFinal = this.formatarStringData(req.data);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)});            
        },       
        executarAcao(acao) {
            if(acao == 'SALVAR') {
                this.salvar();
            } else {
                this.excluir();
            }
        },
        salvar() {          
            let req = {...this.requisicao};
            req['dataInicio'] = this.formatarData(this.dataInicio);
            req['dataFinal'] = this.formatarData(this.dataFinal);            
            this.controlePontoService.lancarFolgaPontoDia(req)
            .then(resp => {
                exibirMensagem(this, resp);		
                this.callback(req.dataInicio, req.dataFinal);
                this.fecharModal();                
            })
            .catch(erro => {
                console.log(erro);
                exibirMensagem(this, erro)
            });            
        },
        excluir() {
            this.requisicao['dataInicio'] = this.folgaExcluir.data;
            this.requisicao['dataFinal'] = this.folgaExcluir.data;
            this.controlePontoService.excluirFolgaPontoDia(this.requisicao)
            .then(resp => {
                exibirMensagem(this, resp);		
                this.callback(this.requisicao.dataInicio, this.requisicao.dataFinal);
                this.fecharModal();                
            })
            .catch(erro => {             
                exibirMensagem(this, erro);
            });  
        }, 
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},        
        formatarStringData(data) {
            if(!data || data instanceof Date) {
                return '';
            } 
            let partes = data.split('-');
            return partes[2] + '/' + partes[1] + '/' + partes[0];
        },
        fecharModal() {
            this.exibirModalNovo = null;
            this.exibirModalExcluir = null;
            this.folgaExcluir = {data: null};      
        }
    },
    created() {
        this.controlePontoService = new ControlePontoService();
    },
}
</script>

<style>

</style>